import { getSection, BRAND } from "@/lib/siteSeo";

// -----------------------------------------------------------------------------
// SectionTagline — a small, dignified sub-headline visible under a
// section's main H1. It reads its copy from /lib/siteSeo.js so every
// section speaks in one voice and copy edits live in ONE file.
//
// Usage inside any hero:
//   <SectionTagline section="family_tree" />
//   <SectionTagline section="health" className="mt-2 text-lg" />
//   <SectionTagline section="unknown-key" fallback="Custom line" />
//
// If you want to hide the small "SocialPulse —" prefix, pass showBrand=false.
// -----------------------------------------------------------------------------

export default function SectionTagline({
  section,
  fallback,
  showBrand = false,
  className = "",
  as: Tag = "p",
  testId,
}) {
  const cfg = section ? getSection(section) : {};
  const text = cfg?.tagline || fallback || BRAND.taglines.connect;
  return (
    <Tag
      className={"text-sm md:text-base opacity-80 " + className}
      data-testid={testId || (section ? `section-tagline-${section}` : "section-tagline")}
      style={{ color: "var(--wofy-text-soft)" }}
    >
      {showBrand ? <><strong>{BRAND.name}</strong> — </> : null}
      {text}
    </Tag>
  );
}
